import React from 'react';

export default function CreditsPage() {
  return (
    <div>
      <h2>Credits</h2>
      <p>Built by Gary Lucas. Thank you to the Pokémon and PokéAPI communities for assets and data used for this demo app.</p>
      <p>Libraries used: React, axios, socket.io-client.</p>
    </div>
  );
}
